import { ActionIcon, Box, Divider } from "@mantine/core";
import { IconArrowBarDown, IconArrowBarToUp } from "@tabler/icons-react";
import ActionButton from "../ActionButton";
import BrainstormContext from "../BrainstormContext";
import ReadContext from "../ReadContext";
import RetrievalContext from "../RetrievalContext";
import { toolIcon } from "./icons";
import classes from "./SharedItem.module.css";
import type { ItemViewProps } from "./types";
import XmlContentRenderer from "./XmlContentRenderer";

export const ICON_SIZE = 32;

export function FunctionOutputItemView({
    item,
    opened,
    onOpen,
    onClose,
    actionButtons,
    containerClassName,
    showActions = true,
    containerRef,
}: ItemViewProps) {
    return (
        <Box className={`${classes.container} ${containerClassName ?? ""}`} ref={containerRef}>
            {showActions && (
                <ActionIcon.Group className={classes.icons}>
                    {item.context && (
                        <>
                            {!opened && (
                                <ActionButton
                                    onClick={onOpen}
                                    label="Show content"
                                    icon={<IconArrowBarDown stroke={1} />}
                                />
                            )}
                            {opened && (
                                <ActionButton
                                    onClick={onClose}
                                    label="Hide content"
                                    icon={<IconArrowBarToUp stroke={1} />}
                                />
                            )}
                        </>
                    )}
                    {actionButtons}
                </ActionIcon.Group>
            )}
            <Box>{toolIcon(item.toolName, ICON_SIZE)}</Box>
            <Box className={classes.content}>
                {opened ? (
                    <Box>
                        {item.retrievalContext && (
                            <>
                                <RetrievalContext context={item.retrievalContext} />
                                <Divider color="gray" label="Retrieval result" labelPosition="center" />
                            </>
                        )}
                        {item.readContext && (
                            <>
                                <ReadContext context={item.readContext} />
                                <Divider color="gray" label="Read result" labelPosition="center" />
                            </>
                        )}
                        {item.brainstormContext && (
                            <>
                                <BrainstormContext context={item.brainstormContext} />
                                <Divider color="gray" label="Brainstorm result" labelPosition="center" />
                            </>
                        )}
                        <XmlContentRenderer content={item.content} />
                    </Box>
                ) : (
                    <Box>TOOL RESULT</Box>
                )}
            </Box>
        </Box>
    );
}
